module.exports = __webpack_public_path__ + "src/img/artist/name08.svg?7632c0d179d9abffb421a44c7ece5fa7";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name08.svg
// module id = 144
// module chunks = 0